import * as RadixTooltip from "@radix-ui/react-tooltip";

import classes from "./styles.module.scss";

import type { ITooltipProps } from "@/components/atoms/tooltip";
import { Typography } from "@/components/atoms/typography";

/**
 * Tooltip component that displays additional information on hover.
 *
 * @param {ITooltipProps} props - The props for the Tooltip component.
 * @param {string} props.text - The text content of the tooltip.
 * @param {string} [props.className] - Additional CSS class name for styling. Optional.
 * @param {ReactNode} props.children - The content that triggers the tooltip.
 * @returns Tooltip The rendered Tooltip component.
 */
export function Tooltip(props: ITooltipProps) {
  const { text, children, pos = "bottom" } = props;

  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          className={classes.label}
          side={pos || "bottom"}
          sideOffset={8}
        >
          <Typography
            color={"inherit"}
            createSpan
            fontSize={"xs"}
            fontWeight={"bold"}
          >
            {text}
          </Typography>
          <RadixTooltip.Arrow className={classes.triangle} />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
    /* <div className={clsx(classes.box, className)}>
    {children}
    <div
      className={clsx(
        classes.label,
        pos === 'right' && classes.right,
        pos === 'left' && classes.left
      )}
    >
      <div
        className={clsx(
          classes.icon,
          pos === 'right' && classes.rightIcon,
          pos === 'left' && classes.leftIcon
        )}
      >
        <div className={classes.triangle}></div>
      </div>
      <div>
        <Typography
          color={'inherit'}
          createSpan
          fontSize={'xs'}
          fontWeight={'bold'}
        >
          {text}
        </Typography>
      </div>
    </div>
  </div>*/
  );
}
